import styled from 'styled-components';
import { Button, Typography } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

type Props = {
  type: 'area' | 'link';
  count: number;
  onConfirm?: () => void;
  onDiscard?: () => void;
};

const MultipleSelectingBar = ({ type, count, onConfirm, onDiscard }: Props) => {
  const { t } = useTranslation();

  return (
    <FloatingContainer>
      <Typography.Text style={{ marginInline: 8 }}>
        {type === 'area'
          ? t('selectingMultipleAreas', { count })
          : t('selectingMultipleLinks', { count })}
      </Typography.Text>
      <div style={{ display: 'flex', gap: '8px', marginLeft: '16px' }}>
        <Button
          type="default"
          shape="round"
          icon={<CloseOutlined />}
          aria-label={t('cancel')}
          onClick={onDiscard}
        >
          {t('cancel')}
        </Button>
        <Button
          type="primary"
          shape="round"
          icon={<CheckOutlined />}
          onClick={onConfirm}
        >
          {t('actions.confirm')}
        </Button>
      </div>
    </FloatingContainer>
  );
};

const FloatingContainer = styled.div`
  position: absolute;
  bottom: 10vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  width: auto;
  background: white;
  box-shadow: 0px 4px 12px #00000026;
  border-radius: 2px;
  display: flex;
  align-items: center;
  padding: 8px;
`;

export { MultipleSelectingBar };
